<ng-template>
  <div class="mat-autocomplete-panel" role="listbox" [id]="id" [ngClass]="_classList" #panel>
    <ng-content></ng-content>
  </div>
</ng-template>
